"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FALLBACK_MESSAGES = void 0;
var FALLBACK_MESSAGES = {
  logicValidation: 'El campo no cumple con la validación.',
  required: 'Campo obligatorio',
  creditCardErrorMessages: {
    cardNumberRequired: 'El número de tarjeta es obligatorio',
    invalidCardNumber: 'El número de tarjeta es inválido',
    holderNameRequired: 'El nombre del titular es obligatorio',
    expiresRequired: 'La fecha de vencimiento es obligatoria',
    invalidExpires: 'La fecha de vencimiento es inválida',
    securityCodeRequired: 'El código de seguridad es obligatorio'
  },
  invalidEmail: 'El email ingresado no es válido',
  invalidCard: 'La tarjeta ingresada no es válida',
  invalidFormat: 'Formato inválido',
  invalidDate: 'Fecha inválida'
};
exports.FALLBACK_MESSAGES = FALLBACK_MESSAGES;